import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/vercel/path0/frontend_next/src/screens/user/Newsletter.tsx");
